import React from 'react'
import { StyledGroup, StyledItem } from './NextMenu.styles'
import type { NextMenuGroupProps, NextMenuItemProps } from './NextMenu.types'

/**
 *  Default representation of item in menu
 * */
export const NextMenuItem = React.forwardRef<
  HTMLDivElement,
  NextMenuItemProps<any>
>(
  (
    { totalSize, ['data-item-index']: itemPositionInList, context, ...props },
    ref
  ) => {
    return (
      <StyledItem
        aria-setsize={context?.items?.length}
        aria-posinset={itemPositionInList + 1}
        ref={ref}
        {...props}
      >
        {context?.getItemLabel?.(context?.items?.[itemPositionInList]) ?? null}
      </StyledItem>
    )
  }
)

/**
 *  Default representation of group with items in menu
 * */
export const NextMenuGroup = React.forwardRef<
  HTMLDivElement,
  NextMenuGroupProps<any>
>(({ children, ...props }, ref) => {
  return (
    <StyledGroup ref={ref} {...props}>
      {children}
    </StyledGroup>
  )
})
